// @ts-nocheck
(function () {
  'use strict';
  window.AIFlorist = window.AIFlorist || {};

  function resolveContext(root) {
    var datasetLocale = normalizeLocaleCode(root && root.dataset ? root.dataset.locale : '');
    var datasetLanguage = normalizeLanguageCode(root && root.dataset ? root.dataset.language : '');
    var pathLocale = getLocaleFromPath(window.location.pathname || '');
    var htmlLang = normalizeLocaleCode(document.documentElement ? document.documentElement.lang : '');
    var browserLang = normalizeLocaleCode(
      (navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language) || ''
    );

    var locale = datasetLocale || pathLocale || htmlLang || browserLang || 'en';
    var language = datasetLanguage || locale.split('-')[0] || 'en';

    return {
      locale: locale,
      language: language,
    };
  }

  function getLocaleFromPath(pathname) {
    var parts = String(pathname || '')
      .split('/')
      .filter(Boolean);
    if (!parts.length) return '';
    var first = parts[0].toLowerCase();
    if (/^[a-z]{2}(-[a-z]{2})?$/.test(first)) return first;
    return '';
  }

  function normalizeLocaleCode(value) {
    var raw = String(value || '').trim().replace('_', '-').toLowerCase();
    if (!raw) return '';
    if (/^[a-z]{2}$/.test(raw)) return raw;
    if (/^[a-z]{2}-[a-z]{2}$/.test(raw)) return raw;
    return '';
  }

  function normalizeLanguageCode(value) {
    var locale = normalizeLocaleCode(value);
    if (!locale) return '';
    return locale.split('-')[0];
  }

  function getChatCopy(language) {
    if (language === 'zh') {
      return {
        title: '\u4e0e Fleur \u5bf9\u8bdd',
        welcome:
          '\u4f60\u597d\uff01\u6211\u662f Fleur\uff0c\u4f60\u7684 AI \u82b1\u827a\u5e08\uff0c\u6211\u4f1a\u4e3a\u4f60\u8bbe\u8ba1\u4e13\u5c5e\u82b1\u793c\u3002\n\n' +
          '\u4e3a\u4e86\u5f00\u59cb\uff0c\u4f60\u53ef\u4ee5\u544a\u8bc9\u6211\uff1a\n' +
          '- **\u82b1\u6750\u7c7b\u578b** \u2014 \u9c9c\u82b1\u3001\u6c38\u751f\u82b1/\u5e72\u82b1\u3001\u8fd8\u662f\u4eff\u771f\u82b1\uff1f\n' +
          '- **\u573a\u5408** \u2014 \u662f\u4ec0\u4e48\u7528\u9014\uff1f\n' +
          '- **\u9884\u7b97** \u2014 \u4f60\u60f3\u63a7\u5236\u5728\u591a\u5c11\u4ef7\u683c\uff1f\n' +
          '- **\u82b1\u6750/\u989c\u8272** \u2014 \u6709\u504f\u597d\u6216\u60f3\u8981\u7684\u98ce\u683c\u5417\uff1f\n' +
          '- **\u6b3e\u5f0f** \u2014 \u82b1\u675f\u3001\u82b1\u74f6\u3001\u684c\u82b1\u7b49\uff1f\n\n' +
          '\u4f60\u53ef\u4ee5\u4e00\u6b21\u628a\u60f3\u6cd5\u90fd\u544a\u8bc9\u6211\uff0c\u4e5f\u53ef\u4ee5\u8fb9\u804a\u8fb9\u5b9a\u3002\n' +
          '*\u5c0f\u63d0\u793a\uff1a\u4f60\u4e5f\u53ef\u4ee5\u544a\u8bc9\u6211\u661f\u5ea7\u6216 MBTI\uff0c\u6211\u4f1a\u5e2e\u4f60\u642d\u914d\u6c14\u8d28\u3002*',
      };
    }
    if (language === 'ja') {
      return {
        title: 'Fleur\u3068\u30c1\u30e3\u30c3\u30c8',
        welcome:
          '\u3053\u3093\u306b\u3061\u306f\uff01\u79c1\u306f Fleur\uff08\u30d5\u30eb\u30fc\u30eb\uff09\u3001\u3042\u306a\u305f\u306e AI \u30d5\u30ed\u30fc\u30ea\u30b9\u30c8\u3067\u3059\u3002\u3042\u306a\u305f\u3060\u3051\u306e\u30a2\u30ec\u30f3\u30b8\u30e1\u30f3\u30c8\u3092\u30c7\u30b6\u30a4\u30f3\u3057\u307e\u3059\u3002\n\n' +
          '\u307e\u305a\u306f\u6b21\u3092\u6559\u3048\u3066\u304f\u3060\u3055\u3044\uff1a\n' +
          '- **\u82b1\u306e\u7a2e\u985e** \u2014 \u751f\u82b1\u30fb\u30d7\u30ea\u30b6\u30fc\u30d6\u30c9/\u30c9\u30e9\u30a4\u30fb\u30a2\u30fc\u30c6\u30a3\u30d5\u30a3\u30b7\u30e3\u30eb\uff1f\n' +
          '- **\u7528\u9014** \u2014 \u3069\u3093\u306a\u30b7\u30fc\u30f3\u3067\u3059\u304b\uff1f\n' +
          '- **\u4e88\u7b97** \u2014 \u3054\u4e88\u7b97\u306f\u3044\u304f\u3089\u3067\u3059\u304b\uff1f\n' +
          '- **\u82b1/\u8272** \u2014 \u304a\u597d\u307f\u306e\u82b1\u3084\u96f0\u56f2\u6c17\u306f\u3042\u308a\u307e\u3059\u304b\uff1f\n' +
          '- **\u30b9\u30bf\u30a4\u30eb** \u2014 \u82b1\u675f\u30fb\u82b1\u74f6\u30fb\u30bb\u30f3\u30bf\u30fc\u30d4\u30fc\u30b9\u306a\u3069\uff1f\n\n' +
          '\u307e\u3068\u3081\u3066\u9001\u3063\u3066\u3044\u305f\u3060\u3044\u3066\u3082\u3001\u304a\u8a71\u3057\u3057\u306a\u304c\u3089\u6c7a\u3081\u3066\u3044\u304f\u306e\u3067\u3082\u5927\u4e08\u592b\u3067\u3059\u3002\n' +
          '*\u30d2\u30f3\u30c8\uff1a\u661f\u5ea7\u3084 MBTI \u3092\u6559\u3048\u3066\u304f\u3060\u3051\u308c\u3070\u3001\u96f0\u56f2\u6c17\u306b\u5408\u308f\u305b\u3066\u3054\u63d0\u6848\u3057\u307e\u3059\u3002*',
      };
    }
    return {
      title: 'Chat with Fleur',
      welcome:
        "Hi! I'm Fleur, your AI florist \u2014 I'll design a custom arrangement just for you.\n\n" +
        "To get started, tell me:\n" +
        "- **Flower type** \u2014 Fresh, preserved/dried, or artificial?\n" +
        "- **Occasion** \u2014 What's it for?\n" +
        "- **Budget** \u2014 How much would you like to spend?\n" +
        "- **Flowers or colours** \u2014 Any favourites or vibes?\n" +
        "- **Style** \u2014 Wrapped bouquet, vase, centerpiece...?\n\n" +
        "Share it all in one message or we can chat it through!\n" +
        "*Psst \u2014 you can even tell me a zodiac sign or MBTI type and I'll match the vibe.*",
    };
  }

  function getChromeCopy(language) {
    if (language === 'zh') {
      return {
        pastChats: '历史对话',
        closeHistory: '关闭历史',
        noPastConversations: '暂无历史对话',
        forgetMe: '忘记我并删除数据',
        flowerLibrary: '花材库',
        browseFlowerLibrary: '浏览花材库',
        chatHistory: '聊天记录',
        newChat: '新对话',
        startNewChat: '开始新对话',
        attachImage: '添加图片',
        inputPlaceholder: '描述你理想中的花束...',
      };
    }
    if (language === 'ja') {
      return {
        pastChats: '過去のチャット',
        closeHistory: '履歴を閉じる',
        noPastConversations: '過去のチャットはまだありません',
        forgetMe: 'データを削除してリセット',
        flowerLibrary: 'フラワーライブラリ',
        browseFlowerLibrary: 'フラワーライブラリを開く',
        chatHistory: 'チャット履歴',
        newChat: '新しいチャット',
        startNewChat: '新しいチャットを開始',
        attachImage: '画像を添付',
        inputPlaceholder: '理想の花束を教えてください...',
      };
    }
    return {
      pastChats: 'Past Chats',
      closeHistory: 'Close history',
      noPastConversations: 'No past conversations yet',
      forgetMe: 'Forget me & delete my data',
      flowerLibrary: 'Flower library',
      browseFlowerLibrary: 'Browse flower library',
      chatHistory: 'Chat history',
      newChat: 'New chat',
      startNewChat: 'Start new chat',
      attachImage: 'Attach image',
      inputPlaceholder: 'Describe your dream bouquet...',
    };
  }

  window.AIFlorist.locale = {
    resolveContext: resolveContext,
    getChatCopy: getChatCopy,
    getChromeCopy: getChromeCopy,
  };
})();
